module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter",
    attrs: {
      "id": "rw-body-Chapter_424112-962227367"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_424112-204042653"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_424112-870685877"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('h1', {
    attrs: {
      "id": "rw-h1_424112-472825377"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781846274633_toc"
    }
  }, [_vm._v("I")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_424112-640784635"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("S")]), _vm._v("omewhere, in one of the many narrative "), _c('span', {
    staticClass: "variable"
  }, [_vm._v("repositories")]), _vm._v(" that have been set up here and there for us to draw on when the world needs a story, it must be possible to find the fable that tells us that people, on their arrival in the realm of the dead, must lay claim to a trait, one only, that characterizes the life they have just led. After all, we need to be able to imagine the afterworld as a pleasant place – that’s a precondition of these fables, and you would have to be quite naïve to believe that an eternal sojourn in a single location with everyone who has ever and will ever die "), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_vm._v("could remain pleasant for very long. According to the fable in question, the wandering souls are grouped according to shared characteristics, from which we can immediately conclude that it must be especially busy in those parts of the hereafter that are filled with people who strove during their lifetime to accumulate as much money as possible, possess fire, become a famous guitarist, famous in any discipline at all, or where the resurrected population consists of all those who let their self-esteem depend on the number of their amorous conquests.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_424112-474081573"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_vm._v("Of course, this fable about the hereafter is "), _c('span', {
    staticClass: "variable"
  }, [_vm._v("actually")]), _vm._v(" a fable about life, which is why even notorious atheists can derive a great deal of pleasure from "), _c('span', {
    staticClass: "variable"
  }, [_vm._v("considering")]), _vm._v(" it as a hypothetical situation. On that icy day in late February, for instance, Madame Verona thought about what she would shortly confess to eternity’s fabled gatekeeper as the chief characteristic of the life that had surrendered its last toehold and was now slipping away from her. It wasn’t so much that she was thinking about "), _c('i', [_vm._v("what")]), _vm._v(" to tell him – she ")]), _c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("had no doubts on that score – it was "), _c('i', [_vm._v("how to put it")]), _vm._v(" that bothered her.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_c('div', {
    staticClass: "paras decoration",
    attrs: {
      "id": "rw-paras-decoration_424112-481254134"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_424112-805570094"
    }
  }, [_vm._v("*")])])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_424112-947185145"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("The one characteristic element with which she would summarize her eighty-two years of existence was that dogs had always sought out her company. There must have been something about her, even when she was very young, that made dogs feel safe around her. As a girl she was often snuffled by passing quadrupeds that immediately begged to be patted, offering to shake hands the way ridiculous people had taught them to. Even more intelligent breeds known for their distrust of children caught a whiff of whatever it is that makes dogs wag their tails, and guard dogs that had been trained to foam at the mouth at the sight of a stranger abandoned all "), _c('span', {
    staticClass: "variable"
  }, [_vm._v("xenophobia")]), _vm._v(" in her presence. In the summer, when many a holidaymaker dumped the family pet on a convenient roadside, she encountered starving dog after starving dog, and would have taken them all home ")]), _c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("with her if not for the presence there of a mother who could scream entire octaves at the mere thought of a dog. The only thing her mother had ever "), _c('span', {
    staticClass: "variable"
  }, [_vm._v("permitted")]), _vm._v(" her was a childish or, more accurately, girlish dedication to guinea pigs, and even then mother dear would have probably suffered a heart attack if one of the creatures had ever escaped its cage. And there was no question of a mother like hers being able to "), _c('span', {
    staticClass: "variable"
  }, [_vm._v("sympathize")]), _vm._v(" with the immature grief of a child digging a hole in the back garden to accommodate the shoe or cigar box that would be lowered into it after the last rites that only children administer to dead animals.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_424112-762709530"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("Madame Verona had not seen her parental home since the day her mother was lowered into that same merciful earth, after which the house was sold to people who showed no interest in the history of their new dwelling. But if she had just once succumbed to a nostalgic impulse to sniff up the atmosphere of her tender years, she could have strolled through the garden knowing it was rooted in a small animal cemetery. It was highly unlikely that anything would ")]), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("be left of the countless cavy cadavers or the birds that had ended up there after leaving a greasy spot on a windowpane, but with a little effort she could have recalled which animal was sleeping the sleep of sleeps under which shrub. More than that, she could have remembered what all those little creatures had been called: Mimi, Cuddles, Fluffy, Skittles, Bill, Dolly, or whatever names thirteen-year-old girls give their pets and later feel a mistaken sense of embarrassment about.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_424112-197077560"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("Nonetheless, in the case of Madame Verona, we should differentiate between a relatively standard love of animals and the power over dogs she enjoyed throughout her life. Although it is questionable whether ‘enjoyed’ is the right word in this context. After stubbornly bringing yet another pitiful stray home with her (wrong again: she didn’t "), _c('i', [_vm._v("bring")]), _vm._v(" them, the dogs simply followed her), she endured her mother’s predictably hysterical outburst and then delivered the animal in question to the shelter, "), _c('span', {
    staticClass: "variable"
  }, [_vm._v("realizing")]), _vm._v(" that imprisonment there was the price of a ")]), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("full stomach and hoping against hope that this dog might be adopted by wiser owners. That last bit is a figure of speech, as it is common knowledge that there is absolutely no point in buying or adopting a dog in the hope of calling yourself its owner; it’s always the dog that chooses the owner, even if that means waiting patiently for rain to rust the chain and long days spent marching.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_424112-062991425"
    }
  }, [_vm._v("It is hard to say when exactly Madame Verona first became aware of her abnormal appeal for dogs, but she was around twenty when she travelled "), _c('span', {
    staticClass: "variable"
  }, [_vm._v("independently")]), _vm._v(" for the first time and ascertained that her peculiarity was just as potent in foreign countries. Of course, many people have been tickled by an unsolicited offer of simple canine friendship and honoured by an animal showing up to present itself as a confidant, even if it’s almost always more trouble than it’s worth.\n         ")])]), _c('p', {
    attrs: {
      "id": "rw-p_424112-053877902"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("She, for instance, suddenly found herself with a sheepdog as "), _c('i', [_vm._v("compagnon de route")]), _vm._v(" on a hiking trip through Portugal. The dog asked nothing of her, he ")]), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("simply followed along behind, days on end, through and over the gentle hills around Coimbra. At night, under the stars, he stretched out on the hard ground that bent her tent pegs, and in the morning he simply resumed "), _c('i', [_vm._v("her")]), _vm._v(" path, after first stretching his front legs in an ancient yawn that displayed every last one of his rotten yellow stalactites and stalagmites. He made no attempt to demand a share of her meals. And she didn’t give him anything either, hoping he would go back to wherever he had come from. Puddles were all he needed and, fortunately, there were plenty of those. Finally, a couple of weeks and many miles later, a stone’s throw from Porto airport, knowing she couldn’t take him home with her, she rejected him with a pointing finger and feigned anger that didn’t come close to convincing him. Then, for the first time, he let her hear his bark, and the sound cut her to the bone. It was a paltry, worn-out yap, no longer capable of impressing even a sheep. Then he turned, in all his loneliness, hoping that a destination would reveal itself.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_424112-458688665"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_c('div', {
    staticClass: "paras decoration",
    attrs: {
      "id": "rw-paras-decoration_424112-725974240"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_424112-326774722"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_424112-198545168"
    }
  }, [_vm._v("When Madame Verona’s thoughts turned to the fable on that cold day in February, another dog was lying at her feet, the kind of farm dog that Renaissance painters cursed for the way the subtle gradations of colour in its coat revealed the copyist’s limitations as a Creator, the mass breeding of which must have stopped sometime in the mid-nineteenth century. A magnificent animal with leadership qualities, gentle through and through, but inclined to boredom. She had vacillated before letting him in, considering her age, but the requests people cannot resist are never asked, they are in the eyes, like the melancholy subservient eyes with which he had stared up at her until she said, ‘Fine, come in, you can live here, but you’d better realize you’re going to survive me, so don’t get too attached.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_424112-984605065"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("The hour at which the dog would be obliged to seek a new master was approaching, and his legendary intuition was undoubtedly making him uneasy. But for the time being he didn’t let that show ")]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("and lay on the cooling feet of Madame Verona, who thought, ‘This is what I’ll say when I get up there – that I’ve always been popular with dogs.’ And it occurred to her that her beloved husband, Monsieur Potter, who had preceded her to the realm of fables, had probably said the very same thing to death’s concierge. He too had always had dogs at his heels. And what could be more logical than Madame Verona and Monsieur Potter being reunited in the terrifying emptiness known as The World to Come? Their being accommodated in different sections of the hereafter would make a mockery of beauty. \n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53eb963f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781846274633_chapter_01.vue
// module id = 75
// module chunks = 0